<template>
  <div class="mb-3">
    <Alert
      type="alert-info"
      text="Keywords are a great way to mimic a human like conversation. 
      Mention the keywords your user can use in conversation and link it to chat that need to be invoked.
      For example: add keywords Hi, Hello, Hey, Start and link them to chat that Greets the user.
      If user sent message contains these keywords, corresponding chat will be started."
    ></Alert>
    <div class="mb-3 rounded" v-for="(item, index) in keywords" :key="index">
      <div class="input-group">
        <input type="text" class="form-control" v-model="item.keyword" placeholder="keyword">
        <select class="form-control" v-model="item.chat">
          <option :value=null>Select chat</option>
          <option v-for="(chat_name, index) in chat_names" :value="chat_name" :key="index">{{chat_name}}</option>
        </select>
        <div class="input-group-append">
          <button @click="removeKeyword(index)" class="btn btn-outline-danger">X</button>
        </div>
      </div>
    </div>
    <button @click="addKeyword" class="btn btn-outline-info btn-block">Add Keyword</button>
  </div>
</template>


<script>
import Alert from "@/components/Alert.vue";


export default{
  name: 'Keywords',
  components:{
    Alert
  },
  props:{
    keywords: Array,
    chat_names: Array
  },
  methods: {
    removeKeyword: function(index){
      this.$emit('removeKeyword',index);
    },
    addKeyword: function(){
      this.$emit('addKeyword',this.keywords);
    },
  }
}
</script>
